import { CreditCardBrands } from '../constants/credit-card';

const IMAGES_ASSETS_URL = 'https://assets.thdstatic.com/images/v1';
const getImagePath = (path: string) => `${IMAGES_ASSETS_URL}${path}`;

export const getCardImagePath = (cardBrand: string): string => {
  switch (cardBrand) {
    case CreditCardBrands.VISA:
      return getImagePath('/credit-card-visa.png');
    case CreditCardBrands.MA:
      return getImagePath('/credit-card-mastercard.png');
    case CreditCardBrands.AMEX:
      return getImagePath('/credit-card-amex.png');
    case CreditCardBrands.DISC:
      return getImagePath('/credit-card-discover.png');
    case CreditCardBrands.HDCOM:
      return getImagePath('/credit-card-commercial-revolving.png');
    case CreditCardBrands.HDCON:
      return getImagePath('/credit-card-hd-consumer.png');
    case CreditCardBrands.PROP:
      return getImagePath('/credit-card-pro-purchase.png');
    case CreditCardBrands.PROX:
      return getImagePath('/credit-card-prox.png');
    default:
      return '';
  }
};

export const checkExpiredCard = (expiryMonth: string, expiryYear: string) => {
  const currentDate = new Date().getTime();
  const selectedDate = new Date(+expiryYear, +expiryMonth).getTime();

  return currentDate > selectedDate;
};

export const listOfMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const expirationMonthValues = listOfMonths.map((month, ind) => {
  const count = ind + 1;
  const value = count < 10 ? '0' + count : count.toString();
  return {
    label: month,
    value,
  };
});

export const currentYear = new Date().getFullYear();

export const expirationYearValues = new Array(20)
  .fill(currentYear)
  .map((year: number, ind) => {
    const nextYear = year + ind;
    return {
      label: nextYear.toString(),
      value: nextYear.toString(),
    };
  });

export const getSiteKey = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.hostname.endsWith('homedepot.com')
    ? '6LfEHBkTAAAAAHX6YgeUw9x1Sutr7EzhMdpbIfWJ'
    : '6Le3GRkTAAAAAPpXON0jcJCLrYZnm-ZqyLhbCLbX';
};
